export const STATUS_PENDING = 'pending';
export const STATUS_COMPLETED = 'completed';
export const STATUS_RUNNING = 'running';
export const STATUS_FAILED = 'failed';
export const STATUS_UNKNOWN = 'unknown';
export const STATUS_SKIPPED = 'skipped';
